import React, { FC, useEffect, useState } from 'react'
import NextHead from 'next/head'
import { useRouter } from 'next/router'

const Head: FC = () => {
    const [currentURL, setCurrentURL] = useState('')
    const { asPath } = useRouter()
    const getHrefLang = 'en-us'

    useEffect(() => {
        setCurrentURL(window.location.href)
    }, [asPath])

    return (
        <NextHead>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
            />
            <link
                rel="manifest"
                href="/stores/ooka_usa_store/site.webmanifest"
                key="site-manifest"
                crossOrigin="use-credentials"
            />
            <link rel="alternate" href={currentURL} hrefLang={getHrefLang} />
        </NextHead>
    )
}

export default Head
